module.exports = __webpack_public_path__ + "static/media/CV-Europass-20200222-Arora-EN.9cca430d.pdf";